import TermsOfUse from './TermsOfUse';

export default TermsOfUse;



// WEBPACK FOOTER //
// ./src/pages/LegalDocuments/TermsOfUse/index.js